import { TagManagerService } from '@services/tag-manager.service';
import { GoogleTagManagerEventEnum } from 'src/app/enums/GoogleTagManagerEvent.enum';
import { GoogleTagManagerModel } from 'src/app/models/google-tag-manager.model';
import { inject, Injectable } from '@angular/core';

@Injectable()
export abstract class GoogleComponent {

  protected readonly tagManagerService = inject(TagManagerService);

  screenViewName: string = '';

  /** Usado por componentes com screen/section dinâmicas (pages) */
  addTagInPageChange(name: string, sectionApp: string, screenName: string, screenType: string) {
    this.addTagManagerInteraction('select:menu:click', name, sectionApp, screenName, screenType);
    this.screenViewName = name;
    this.addTagManagerScreenView(sectionApp, screenName, screenType);
  }

  addTagManagerScreenView(sectionApp: string, screenName: string, screenType: string) {
    const model = this.buildTagModel(GoogleTagManagerEventEnum.screenView, null, null, sectionApp, screenName, screenType);
    this.tagManagerService.pushTag(model);
  }

  addTagManagerInteraction(elementType: string, elementContent: string, sectionApp: string, screenName: string, screenType: string) {
    const model = this.buildTagModel(GoogleTagManagerEventEnum.interaction, elementType, elementContent, sectionApp, screenName, screenType);
    this.tagManagerService.pushTag(model);
  }

  /** Usado por componentes com screen/section estáticas (alerts/modals) */
  protected pushScreenView(sectionApp: string, screenName: string, screenType: string): void {
    const model = this.buildTagModel(GoogleTagManagerEventEnum.screenView, null, null, sectionApp, screenName, screenType);
    this.tagManagerService.pushTag(model);
  }

  protected buildTagInteraction(elementType: string, elementContent: string, sectionApp: string, screenName: string, screenType: string): GoogleTagManagerModel {
    return this.buildTagModel(GoogleTagManagerEventEnum.interaction, elementType, elementContent, sectionApp, screenName, screenType);
  }

  /** Usado por componentes que recebem sourceScreen como @Input */
  protected buildTagFromSourceScreen(event: GoogleTagManagerEventEnum, elementType: string, elementContent: string, sourceScreen: string, screenType: string = 'modal'): GoogleTagManagerModel {
    const section = sourceScreen ? sourceScreen.split(':')[0] : '';
    return this.buildTagModel(event, elementType, elementContent, section, sourceScreen, screenType);
  }

  private buildTagModel(
    event: GoogleTagManagerEventEnum,
    elementType: string,
    elementContent: string,
    sectionApp: string,
    screenName: string,
    screenType: string,
  ): GoogleTagManagerModel {
    const model = new GoogleTagManagerModel();
    model.event = event;
    model.element_type = elementType;
    model.element_content = `none:${elementContent}:none`;
    model.section_app = sectionApp;
    model.screen_type = screenType;
    model.screen_name = this.screenViewName == null ? screenName : `${screenName}:${this.screenViewName}`;
    return model;
  }

}
